import { VOImage } from "../../model/DataStructure.js";
import { AbstractImageItem } from "./AbstractImageItem.js";

export class HtmlImageItem extends AbstractImageItem<HTMLDivElement> {

    constructor(image: VOImage, screenWidth: number) {
        super(image, screenWidth);
    }

    protected createElement(image: VOImage): void {
        this.element = document.createElement("div");
        this.element.className = "image-item";
        if (image.canvas) {
            this.element.appendChild(image.canvas);
        }
        else if (image.image.url) {
            this.element.innerHTML = `
            <img src="${image.image.url}"></img>
            `;
        }
        this.element.style.width = this.width + "px";
        this.element.style.height = this.height + "px";
    }

    protected setVisibility(visible: boolean): void {
        this.element.classList.toggle("hidden", !visible);
    }

    protected setTransform(x: number, y: number, scale: number): void {
        this.element.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
    }
}